import React from 'react';
import ContainerWrapper from "../../../designSystem/organisms/ContainerWrapper/ContainerWrapper";
import Otp from '../../../designSystem/molecules/Otp/Otp';
import BottomSheet from "../../../designSystem/organisms/BottomSheet";
import { noop } from 'lodash-es';

import "./EnterOtp.scss"

const EnterOtp = ({
  ctaTitle,
  screenDataAid,
  otpErrorMessage,
  otpProps,
  headerProps,
  bottomSheetProps,
  isBottomSheetOpen,
  handleSubmit,
  handleOtpResend,
  closeBottomSheet,
  handlePrimaryClick,
  handleSecondaryClick,
  isButtonLoading,
  onChange,
  subtitle,
  sendEvents = noop,
}) => {
  return (
    <ContainerWrapper
      noPadding
      headerProps={headerProps}
      footer={{
        button1Props: {
          title: ctaTitle,
          onClick: handleSubmit,
          isLoading: isButtonLoading,
          hideMenuBar: true,
        }
      }}
      dataAid={screenDataAid}
      eventData={sendEvents()}
      className="enter-otp-container"
    >
      <div className="enter-otp">
        <Otp
          errorMessage={otpErrorMessage}
          onClickButton={handleOtpResend}
          {...otpProps}
          onChange={onChange}
        />
      </div>
      {
        bottomSheetProps &&
        <BottomSheet
          onClose={closeBottomSheet}
          onPrimaryClick={handlePrimaryClick}
          onSecondaryClick={handleSecondaryClick}
          isOpen={isBottomSheetOpen}
          {...bottomSheetProps}
          subtitle={subtitle || bottomSheetProps.subtitle}
        />
      }
    </ContainerWrapper>
  )
}

export default EnterOtp